import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
import React, { useEffect, useState } from "react";

const DeleteNodeModal = ({ open, onClose, onSubmit }) => {
  const handleSubmit = () => {
    onSubmit();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          width: "90%",
          maxWidth: "none",
          borderRadius: "1rem",
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <DialogTitle sx={{ fontSize: "24px" }} align="center">
        {I18n.get("Delete node")}
      </DialogTitle>
      <DialogContent>
        {I18n.get("Are you sure you want to delete this node?")}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {I18n.get("Close")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            backgroundColor: "rgb(52, 71, 103)",
            color: "rgb(255, 255, 255)",
            "&:hover": {
              backgroundColor: "rgb(40, 55, 80)",
            },
          }}
        >
          {I18n.get("Delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DeleteNodeModal;
